module.exports = __webpack_public_path__ + "static/img/4.94c9a5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/users/4.jpg
// module id = NFs6
// module chunks = 17